import { combineReducers } from 'redux';
import { ModalState, modalReducer } from 'redux/reducers/modal.reducer';
import { MyFavoriteState, myFavoriteReducer } from 'redux/reducers/components/myFavorite.reducer';
import { ResourcesState, resourcesReducer } from './components/resources.reducer';
import { SystemState } from 'redux/reducers/system/types';
import { systemReducer } from 'redux/reducers/system/reducer';

export interface RootReducersState {
  modal: ModalState;
  myFavorite: MyFavoriteState;
  resources: ResourcesState;
  system: SystemState;
};

export const rootReducers = combineReducers<RootReducersState>({
  modal: modalReducer,
  myFavorite: myFavoriteReducer,
  resources: resourcesReducer,
  system: systemReducer
});
